// src/components/Login/ForgotPasswordBox.js
import React, { useState } from 'react';
import './Login.css';

export default function ForgotPasswordBox({ onBack }) {
  const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle' | 'submitting' | 'done'
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || status === 'submitting') return;

    setStatus('submitting');
    setError('');

    try {
      const res = await fetch(`${API_URL}/api/password/forgot`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      if (!res.ok) {
        let msg = 'Error sending reset request.';
        try {
          const data = await res.json();
          msg = data?.error || msg;
        } catch {
          msg = 'Could not send request.';
        }
        throw new Error(msg);
      }

      await res.json();
      setStatus('done');
    } catch (err) {
      setError(err.message || 'Network error occurred.');
      setStatus('idle');
    }
  };

  if (status === 'done') {
    return (
      <div>
        <p className="account-success-message">
          If an account exists for <strong>{email}</strong>, you’ll receive a password reset email shortly.
        </p>
        <button className="submit-button" onClick={onBack}>
          Back to Login
        </button>
      </div>
    );
  }

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      {/* Email */}
      <div className="form-group">
        <label htmlFor="fp-email">Email</label>
        <input
          id="fp-email"
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={status === 'submitting'}
          style={{ fontSize: '16px' }}
        />
      </div>

      {error && <p className="error-message">{error}</p>}

      <button
        className="submit-button"
        type="submit"
        disabled={!email || status === 'submitting'}
      >
        {status === 'submitting' ? 'Sending…' : 'Send Reset Link'}
      </button>

      <div className="signup-link" style={{ marginTop: '0.5rem' }}>
        <button
          type="button"
          className="link-button"
          onClick={onBack}
          disabled={status === 'submitting'}
        >
          Back to Login
        </button>
      </div>
    </form>
  );
}
